var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0233 11.0782L14.8786 13.9328L13.9353 14.8762L11.0806 12.0208C10.0184 12.8723 8.69727 13.3354 7.33594 13.3335C4.02394 13.3335 1.33594 10.6455 1.33594 7.3335C1.33594 4.0215 4.02394 1.3335 7.33594 1.3335C10.6479 1.3335 13.3359 4.0215 13.3359 7.3335C13.3379 8.69483 12.8748 10.016 12.0233 11.0782ZM10.6859 10.5835C11.532 9.71342 12.0045 8.54712 12.0026 7.3335C12.0026 4.75483 9.91394 2.66683 7.33594 2.66683C4.75727 2.66683 2.66927 4.75483 2.66927 7.3335C2.66927 9.9115 4.75727 12.0002 7.33594 12.0002C8.54956 12.0021 9.71586 11.5296 10.5859 10.6835L10.6859 10.5835Z",
    fill: "#002856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.cb535e56377123f7cdfce9f2b6bf80da.svg";
export { ForwardRef as ReactComponent };